import React from 'react';
//import 'bootstrap/dist/css/bootstrap.css';
import Routes from './Routes';
import { BrowserRouter } from 'react-router-dom';
import { Auth } from './functions/Auth';
import Header from './components/template/Header';
import Footer from './components/template/Footer';

import './App.css';

export default function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Auth>
          <Header />
          <div className="container">
            <br />
            <Routes />
            <br />
          </div>
          <Footer />
        </Auth>
      </BrowserRouter>
    </div>
  );
}
